import type { Agent } from '@/types';
import type { AgentResponseDto } from '@/types';
import { BaseAdapter } from './base.adapter';

export class AgentAdapter extends BaseAdapter {
  /**
   * Transform agent response DTO to domain entity
   */
  static fromApi(dto: AgentResponseDto): Agent {
    return {
      id: dto.id,
      name: dto.name,
      email: dto.email,
      avatar: dto.avatar,
      role: dto.role,
      active: dto.active,
      accountId: dto.accountId,
      createdAt: dto.createdAt,
      updatedAt: dto.updatedAt
    };
  }

  /**
   * Transform array of agent response DTOs to domain entities
   */
  static fromApiList(dtos: AgentResponseDto[]): Agent[] {
    return dtos.map((dto) => this.fromApi(dto));
  }
}

